/**
 * @file
 * @prettier
 */

import { InitializeRepaymentOptionsPages } from "./repaymentOptionsPages.js";

export function InitializeSecureBorrowerRepaymentOptionsRepaymentCalculatorPage() {
  InitializeRepaymentOptionsPages();
}
